import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { useApiQuery } from './useApiQuery';
import { useSelector } from 'react-redux';

const useGetInsightRules = ({ useruuid }) => {
  const trans = useSelector(translator);
  const insightRulesApi = useSelector((state) => state.apis.insightRulesApi);

  return useApiQuery(
    ['getInsightRules', useruuid],
    () =>
      new Promise((resolve, reject) => {
        insightRulesApi.fetchInsightRules(
          useruuid,
          {},
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              resolve(data?.insight_rules || []);
            },
            errorCallback: (err) => {
              reject(err);
            },
          })
        );
      }),
    { enabled: !!useruuid, refetchOnMount: true, staleTime: 0 }
  );
};

export default useGetInsightRules;
